const update = {
  namespaced: true,
  state: {
    groupActive: {}
  },

  getters: {
    groupActiveInfo(state) {
      return  state.groupActive
    }
  },

  mutations: {
    UPDATE_GROUP_ACTIVE: (state, groupActive) => {
      state.groupActive = groupActive
    },
    
  },

  actions: {
    updateGrouActive ({ commit }, groupActive) {
      commit('UPDATE_GROUP_ACTIVE', groupActive)
    },
  }
}

export default update



// WEBPACK FOOTER //
// ./src/components/store/group.js